module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "team"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team_mbox"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'team_type',
        params: {
          teamtypeid: 1
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.menTeam))])], 1), _vm._v(" "), _c('div', {
    staticClass: "team_mbox2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'team_type',
        params: {
          teamtypeid: 0
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.womenTeam))])], 1), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])]) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "teams": _vm.teams
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e46ae66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Team.vue
// module id = 1267
// module chunks = 4